import React from 'react';
import EnumDropdown from './EnumDropdown';
import { DefaultDropdownProps } from './dropdownHelper';

export const LEGAL_ENTITY = {
  SYBERRY_CIS: 'ООО «Сайберри СиАйЭс»',
  SYBERRY_SP_ZOO: 'Syberry spółka z ograniczoną odpowiedzialnością',
  SYBERRY_CORPORATION: 'Syberry Corporation',
};

export type LegalEntityType = keyof typeof LEGAL_ENTITY;

interface LegalEntityEnumProps extends Omit<DefaultDropdownProps, 'options'> {}

const LegalEntityEnum = ({ ...props }: LegalEntityEnumProps) => {
  return <EnumDropdown {...props} options={LEGAL_ENTITY} />;
};

export default LegalEntityEnum;
